import React, { FC } from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';
import Avatar from './shared/Avatar';
import _Container from "UserCard-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/UserCard.tsx?styleId=Container";
import _UserInfo from "UserCard-UserInfo.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/UserCard.tsx?styleId=UserInfo";
import _Name from "UserCard-Name.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/UserCard.tsx?styleId=Name";
import _Affiliation from "UserCard-Affiliation.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/UserCard.tsx?styleId=Affiliation";


const PLACEHOLDER_PHOTO = '//a.academia-assets.com/images/s65_no_pic.png';

const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const UserInfo = /*#__PURE__*/styled("div", null, {
  displayName: "UserInfo",
  styles: _UserInfo
});

const Name = /*#__PURE__*/styled(Body, null, {
  displayName: "Name",
  styles: _Name
});

const Affiliation = /*#__PURE__*/styled(Body, null, {
  displayName: "Affiliation",
  styles: _Affiliation
});

export type User = {
  affiliation?: string;
  displayName: string;
  photo?: string;
  /**
   * Determines whether the avatar should render with
   * a wrapping `a` tag or a wrapping `div`.
   * This is useful if you want to use this component inside
   * of a link, since `a` tags cannot contain other `a` tags.
   */
  profileUrl?: string;
};

export type Props = User & {
  /**
   * Allow external stlying via astroturf's `styled` function.
   */
  className?: string;
  size?: 'regular' | 'small';
  truncateText?: boolean;
};

const UserCard: FC<Props> = ({
  affiliation,
  className,
  displayName,
  photo = PLACEHOLDER_PHOTO,
  profileUrl,
  size = 'regular',
  truncateText = false,
}) => (
  <Container className={className} small={size === 'small'}>
    <Avatar
      fullName={displayName}
      photoUrl={photo}
      profileUrl={profileUrl}
      small={size === 'small'}
    />
    <UserInfo>
      <Name
        size={size === 'small' ? 'sm' : 'md'}
        bold
        truncateText={truncateText}
      >
        {displayName}
      </Name>
      <Affiliation
        size={size === 'small' ? 'xs' : 'sm'}
        truncateText={truncateText}
      >
        {affiliation}
      </Affiliation>
    </UserInfo>
  </Container>
);

export default UserCard;
